import HeadTable from '../ModalTable/HeadTable';
import { formatPriceUSD } from '../TickersModal/helper';
import { IProxyLimitToken } from './TokensTable';
import { useStatsTableData } from './useStatsTableData';

interface IStatsTableProps {
  tokens?: IProxyLimitToken[];
}

const StatsTable = ({ tokens }: IStatsTableProps) => {
  const columns = useStatsTableData();

  const totalUSD = tokens?.reduce(
    ({ quote, quote24 }, { tokenInfo }) => ({
      quote: quote + tokenInfo.quote,
      quote24: quote24 + tokenInfo.quote_24h,
    }),
    { quote: 0, quote24: 0 }
  );

  const renderColumn = (id: string) => {
    switch (id) {
    case 'total':
      return (
        <>
          <span>Value: {formatPriceUSD(totalUSD?.quote)}</span>
          <span>Value 24h: {formatPriceUSD(totalUSD?.quote24)}</span>
        </>
      );
    default:
      return '';
    }
  };

  return <HeadTable columns={columns} renderColumn={renderColumn} />;
};

export default StatsTable;
